(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$(document).on("click", "[data-referral-page]", function() {
		var link = this;
		var target = link.href;
		link.href = "/leave/?to=" + encodeURIComponent(target);

		window.setTimeout(function() {
			link.href = target;
		}, 500);
	});
})();
